import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WarehouseIcon, SearchIcon, FilterIcon, MapPinIcon, TrendingUpIcon, AlertCircleIcon, PackageIcon } from 'lucide-react';
import { GlobalAlertsModal } from '../components/GlobalAlertsModal';
const mockWarehouses = [{
  id: 'ir1',
  code: 'IR1',
  name: 'Alkhorayef Manufacture - Riyadh',
  address: 'Riyadh Industrial Area',
  country: 'Saudi Arabia',
  countryCode: 'SA',
  stockPercentage: 0,
  machineCount: 0,
  alerts: ['Low Stock'],
  status: 'critical'
}, {
  id: 'iu1',
  code: 'IU1',
  name: 'Pierce - San Antonio',
  address: '6203 Woodlake Center TEXAS San Antonio',
  country: 'United States',
  countryCode: 'US',
  stockPercentage: 64,
  machineCount: 65,
  alerts: [],
  status: 'good'
}, {
  id: 'is2',
  code: 'IS2',
  name: 'AISco - Albacete',
  address: 'Avenida Sexta nº 5 Polígono Industrial Campo LLano Albacete',
  country: 'Spain',
  countryCode: 'ES',
  stockPercentage: 0,
  machineCount: 0,
  alerts: ['Order Required'],
  status: 'critical'
}, {
  id: 'ir5',
  code: 'IR5',
  name: 'Oracle Master',
  address: 'Riyadh',
  country: 'Saudi Arabia',
  countryCode: 'SA',
  stockPercentage: 45,
  machineCount: 22,
  alerts: [],
  status: 'warning'
}, {
  id: 'ie5',
  code: 'IE5',
  name: 'AIC TOM Egypt - Pivots',
  address: 'Cairo',
  country: 'Egypt',
  countryCode: 'EG',
  stockPercentage: 78,
  machineCount: 34,
  alerts: ['Low Stock'],
  status: 'good'
}];
const countryFlags: Record<string, string> = {
  US: '🇺🇸',
  SA: '🇸🇦',
  ES: '🇪🇸',
  EG: '🇪🇬'
};
export function WarehouseList() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [isGlobalAlertsOpen, setIsGlobalAlertsOpen] = useState(false);
  const totalWarehouses = mockWarehouses.length;
  const criticalCount = mockWarehouses.filter(w => w.status === 'critical').length;
  const totalMachines = mockWarehouses.reduce((sum, w) => sum + w.machineCount, 0);
  const avgStock = mockWarehouses.reduce((sum, w) => sum + w.stockPercentage, 0) / totalWarehouses;
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-712">
      <div className="bg-white border-b border-gray-200" data-id="element-713">
        <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-714">
          <div className="flex items-center gap-4 mb-8" data-id="element-715">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/30" data-id="element-716">
              <WarehouseIcon className="w-7 h-7 text-white" data-id="element-717" />
            </div>
            <div data-id="element-718">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-719">
                Warehouse Management
              </h1>
              <p className="text-gray-600 text-sm mt-1" data-id="element-720">
                Monitor and manage your global inventory
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-721">
            <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg p-5 text-white shadow-lg shadow-blue-500/30" data-id="element-722">
              <div className="flex items-center justify-between" data-id="element-723">
                <WarehouseIcon className="w-6 h-6 opacity-70" data-id="element-724" />
                <div className="text-right" data-id="element-725">
                  <p className="text-3xl font-bold" data-id="element-726">{totalWarehouses}</p>
                  <p className="text-sm opacity-80 mt-1" data-id="element-727">Locations</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg p-5 border border-gray-200" data-id="element-728">
              <div className="flex items-center justify-between" data-id="element-729">
                <PackageIcon className="w-6 h-6 text-blue-500" data-id="element-730" />
                <div className="text-right" data-id="element-731">
                  <p className="text-3xl font-bold text-gray-900" data-id="element-732">
                    {totalMachines}
                  </p>
                  <p className="text-sm text-gray-600 mt-1" data-id="element-733">Total Machines</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg p-5 border border-gray-200" data-id="element-734">
              <div className="flex items-center justify-between" data-id="element-735">
                <TrendingUpIcon className="w-6 h-6 text-blue-500" data-id="element-736" />
                <div className="text-right" data-id="element-737">
                  <p className="text-3xl font-bold text-gray-900" data-id="element-738">
                    {avgStock.toFixed(0)}%
                  </p>
                  <p className="text-sm text-gray-600 mt-1" data-id="element-739">Avg Stock</p>
                </div>
              </div>
            </div>
            {criticalCount > 0 && <div onClick={() => setIsGlobalAlertsOpen(true)} className="bg-red-50 rounded-lg p-5 border border-red-200 cursor-pointer hover:bg-red-100 hover:shadow-lg transition-all group" data-id="element-740">
                <div className="flex items-center justify-between" data-id="element-741">
                  <AlertCircleIcon className="w-6 h-6 text-red-600 group-hover:scale-110 transition-transform" data-id="element-742" />
                  <div className="text-right" data-id="element-743">
                    <p className="text-3xl font-bold text-red-600" data-id="element-744">
                      {criticalCount}
                    </p>
                    <p className="text-sm text-red-700 mt-1" data-id="element-745">Critical Alerts</p>
                  </div>
                </div>
                <p className="text-xs text-red-700 font-semibold mt-3 group-hover:underline" data-id="element-746">
                  Click to view all critical alerts →
                </p>
              </div>}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-747">
        <div className="flex items-center gap-4 mb-6" data-id="element-748">
          <div className="flex-1 relative" data-id="element-749">
            <SearchIcon className="w-5 h-5 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" data-id="element-750" />
            <input type="text" placeholder="Search warehouses..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-white text-gray-900 pl-12 pr-4 py-3 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all" data-id="element-751" />
          </div>
          <button className="flex items-center gap-2 px-5 py-3 bg-white text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors" data-id="element-752">
            <FilterIcon className="w-5 h-5" data-id="element-753" />
            <span className="font-medium" data-id="element-754">Filters</span>
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-755">
          {mockWarehouses.map(warehouse => <div key={warehouse.id} onClick={() => navigate(`/warehouse/${warehouse.id}`)} className="group bg-white rounded-lg border border-gray-200 hover:border-blue-400 hover:shadow-xl transition-all cursor-pointer" data-id="element-756">
              <div className="p-5" data-id="element-757">
                <div className="flex items-center justify-between mb-3" data-id="element-758">
                  <div className="flex items-center gap-2" data-id="element-759">
                    <div className="px-2.5 py-1 bg-blue-50 rounded-md border border-blue-200" data-id="element-760">
                      <span className="text-xs font-semibold text-blue-700" data-id="element-761">
                        {warehouse.country}
                      </span>
                    </div>
                  </div>
                  {warehouse.status === 'critical' && <div className="flex items-center gap-1 px-2 py-1 bg-red-100 rounded" data-id="element-762">
                      <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-763"></div>
                      <span className="text-xs font-semibold text-red-700" data-id="element-764">
                        Critical
                      </span>
                    </div>}
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 min-h-[3.5rem] group-hover:text-blue-600 transition-colors duration-200" data-id="element-765">
                  {warehouse.name}
                </h4>
                <div className="flex items-start gap-2 mb-4" data-id="element-766">
                  <MapPinIcon className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-767" />
                  <p className="text-sm text-gray-600 line-clamp-2 leading-relaxed" data-id="element-768">
                    {warehouse.address}
                  </p>
                </div>
                {warehouse.alerts.length > 0 && <div className="mb-4 space-y-2" data-id="element-769">
                    {warehouse.alerts.map((alert, idx) => <div key={idx} className="flex items-center gap-2 px-3 py-2 bg-red-50 rounded border border-red-200" data-id="element-770">
                        <AlertCircleIcon className="w-4 h-4 text-red-600" data-id="element-771" />
                        <span className="text-sm font-medium text-red-700" data-id="element-772">
                          {alert}
                        </span>
                      </div>)}
                  </div>}
                <div className="grid grid-cols-2 gap-3 pt-4 border-t border-gray-100" data-id="element-773">
                  <div className="text-center p-3 bg-gray-50 rounded" data-id="element-774">
                    <p className="text-xs text-gray-600 mb-1" data-id="element-775">Stock Level</p>
                    <p className={`text-2xl font-bold ${warehouse.stockPercentage < 30 ? 'text-red-600' : 'text-gray-900'}`} data-id="element-776">
                      {warehouse.stockPercentage}%
                    </p>
                  </div>
                  <div className="text-center p-3 bg-gray-50 rounded" data-id="element-777">
                    <p className="text-xs text-gray-600 mb-1" data-id="element-778">Machines</p>
                    <p className="text-2xl font-bold text-gray-900" data-id="element-779">
                      {warehouse.machineCount}
                    </p>
                  </div>
                </div>
              </div>
              <div className="px-5 py-3 bg-gray-50 border-t border-gray-100 group-hover:bg-blue-50 transition-colors" data-id="element-780">
                <span className="text-sm font-semibold text-blue-600" data-id="element-781">
                  View Details →
                </span>
              </div>
            </div>)}
        </div>
      </div>
      <GlobalAlertsModal isOpen={isGlobalAlertsOpen} onClose={() => setIsGlobalAlertsOpen(false)} data-id="element-782" />
    </div>;
}